import React from "react";
import "./style.scss";
import Download from "../../../components/Download/Download";
const DownloadPage = () => {
  return (
    <div className="download_page_wrapper">
      <Download />
    </div>
  );
};
export default DownloadPage;
